import LoadingButton from './LoadingButton';

export { LoadingButton };
